import { cacheApi } from '../utils/cachingUtils';
import bedev1Services from './bedev1Services';

const cacheKey = {
  gameSort: 'gameSort'
};

export const getGameSorts = async () => {
  return cacheApi(cacheKey.gameSort, bedev1Services.getGameSorts, cache => {
    // NOTE (07/22/21,jcountryman): Expiry is shared across all sorts
    return cache.time + cache.data.sorts[0].tokenExpiryInSeconds > new Date().getTime();
  });
};

export default {
  getGameSorts
};
